"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNMASK_VERSION = exports.IMMORTAL_ERA = exports.DEFAULT_VERSION = exports.EMPTY_U8A = exports.BIT_UNSIGNED = exports.BIT_SIGNED = void 0;
exports.BIT_SIGNED = 0b10000000;
exports.BIT_UNSIGNED = 0;
exports.EMPTY_U8A = new Uint8Array();
exports.DEFAULT_VERSION = 4;
exports.IMMORTAL_ERA = new Uint8Array([0]);
exports.UNMASK_VERSION = 0b01111111;
